export default __webpack_public_path__ + "d82ef9485feb54ad812d0554a6da7f5a.svg";